import { createTheme, PaletteColor, PaletteColorOptions } from "@mui/material/styles";
import { cyan, orange, teal } from "@mui/material/colors";

declare module "@mui/material/styles" {

  /* paletteでincomeColor, expenseColor, balanceColorを使用するための型拡張 */
  interface Palette {
    incomeColor: PaletteColor;
    expenseColor: PaletteColor;
    balanceColor: PaletteColor;
  }
  interface PaletteOptions {
    incomeColor?: PaletteColorOptions;
    expenseColor?: PaletteColorOptions;
    balanceColor?: PaletteColorOptions;
  }
}

export const theme = createTheme({
  typography: {
    fontFamily: 'Noto Sans JP, sans-serif, Roboto, "Helvetica Neue", Arial, sans-serif',
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontSize: "2.5rem",
      fontWeight: 500,
      "@media (max-width:600px)": {
        fontSize: "1.8rem",
      },
    },
    h2: {
      fontSize: "2rem",
      "@media (max-width:600px)": {
        fontSize: "1.5rem",
      },
    },
    h5: {
      fontSize: "1.25rem",
      "@media (max-width:600px)": {
        fontSize: "1.0rem",
      },
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.5,
      "@media (max-width:600px)": {
        fontSize: "0.875rem",
      },
    },
  },

  palette: {
    background: {
      default: "#101010"
    },
    text: {
      primary: "#3f3f3f",
    },
    divider: "#dedede",
    incomeColor: {  /* 型を拡張しておく */
      main: cyan[400],
      light: cyan[100],
      dark: cyan[600],
    },
    expenseColor: {
      main: orange[400],
      light: orange[100],
      dark: orange[600],
    },
    balanceColor: {
      main: teal[400],
      light: teal[100],
      dark: teal[600],
    }
  }
})
